// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M5.04 4.464c0 2.16 1.728 3.96 3.96 3.96s3.96-1.728 3.96-3.96S11.232.504 9 .504s-3.96 1.8-3.96 3.96zm-3.384 12.96A7.329 7.329 0 0 1 9 10.08c4.104 0 7.344 3.24 7.344 7.344z'
  />
);

export const viewBox = '0 0 18 18';
